import styled from '@emotion/styled'

export const Warp = styled.div`
  /* custom table 
  table {
    border: 0px !important;
  }*/

  /* custom thead 
  thead,
  th {
    border: 0px !important;
  }*/

  /* custom tbody 
  .fc-daygrid-day,
  td {
    border: 0px;
  }
  tbody .fc-scrollgrid-sync-inner {
    border-top: 2px solid #cccccc;
    margin: 0px 4px;
  }
  .fc-view-harness {
    z-index: 0;
  }*/

  /* custom text */
  thead .fc-day {
    text-align: right;
    font-weight: 600;
  }

  /* custom events */
  .fc-daygrid-event {
    border-radius: 8px;
    padding-left: 5px;
  }

  /* hide scroller */
  /* .fc-scroller {
    overflow: hidden !important;
  } */

  .fc-day-today {
    background-color: #868686ff !important;
  }

  .fc-h-event .fc-event-main {
    font-size: 16px !important;
  }

  .fc .fc-popover {
    z-index: 20;
  }

  .leave-approved.fc-h-event {
    background-color: #0a9941 !important;
    border-color: #0a9941 !important;
  }

  .leave-pending.fc-h-event {
    background-color: #ffc107 !important;
    border-color: #ffc107 !important;
  }
  .leave-pending-cancellation.fc-h-event {
    background-color: #f59e0b !important;
    border-color: #f59e0b !important;
  }
  .leave-reject.fc-h-event {
    background-color: #f10a0a !important;
    border-color: #f10a0a !important;
  }
  .leave-partial-approved.fc-h-event {
    background-color: #f35acd !important;
    border-color: #f35acd !important;
  }
  .leave-partial-cancellation.fc-h-event {
    background-color: #ab47bc !important;
    border-color: #ab47bc !important;
  }

  .leave-approved.fc-h-event .fc-event-main,
  .leave-pending.fc-h-event .fc-event-main,
  .leave-pending-cancellation.fc-h-event .fc-event-main,
  .leave-reject.fc-h-event .fc-event-main,
  .leave-partial-approved.fc-h-event .fc-event-main,
  .leave-partial-cancellation.fc-h-event .fc-event-main {
    color: #ffffff !important;
  }

  .leave-event-content {
    align-items: center;
    display: flex;
    gap: 4px;
    min-width: 0;
    width: 100%;
  }

  .leave-event-status-indicator {
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.85);
    border-radius: 3px;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
    display: inline-flex;
    flex: 0 0 auto;
    font-size: 11px;
    font-weight: 700;
    height: 16px;
    justify-content: center;
    line-height: 1;
    width: 16px;
  }

  .leave-event-time {
    flex: 0 0 auto;
    font-size: 11px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
  }

  .leave-event-title {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .holiday-cell {
    background-color: transparent !important;
    overflow: visible !important;
    position: relative;
    z-index: 3;
  }

  .holiday-cell .fc-daygrid-day-frame {
    overflow: visible !important;
    position: relative;
  }

  .holiday-cell .fc-daygrid-day-top {
    position: absolute;
    right: 4px;
    top: 4px;
    z-index: 20;
  }

  .holiday-cell .fc-daygrid-day-number {
    align-items: center;
    background-color: #ff4444ff !important;
    border-radius: 999px;
    color: #000 !important;
    cursor: help;
    display: inline-flex;
    height: 28px;
    justify-content: center;
    line-height: 28px;
    overflow: visible;
    padding: 0 !important;
    position: relative;
    width: 28px;
  }

  .holiday-cell .fc-daygrid-day-number[data-holiday-title]:hover::after {
    background-color: #ffffff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    color: #000;
    content: attr(data-holiday-title);
    font-size: 12px;
    line-height: 1.3;
    max-width: calc(100vw / 7 - 16px);
    min-width: 100px;
    padding: 6px 8px;
    pointer-events: none;
    position: absolute;
    right: 0;
    text-align: left;
    top: 32px;
    transform: none;
    white-space: normal;
    z-index: 999;
  }

  .holiday-cell .fc-daygrid-day-events {
    padding-top: 32px;
  }

  .holiday-event.fc-daygrid-event {
    background-color: transparent !important;
    border-color: transparent !important;
    color: #000 !important;
    margin-top: 2px;
    max-width: 100%;
    overflow: hidden;
    padding: 0 4px;
    white-space: normal;
  }

  .holiday-event .fc-event-main {
    color: #000 !important;
    font-size: 12px !important;
    line-height: 1.2;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
  }

  ${({ fillAvailable }) =>
    fillAvailable &&
    `
      @media (min-width: 1200px) {
        flex: 1;
        height: 100%;
        min-height: 0;
        min-width: 0;

        thead .fc-day {
          color: #637086;
          font-size: 12px;
          font-weight: 400;
        }

        .fc-daygrid-event {
          border-radius: 4px;
        }

        .fc-day-today {
          background-color: transparent !important;
        }

        .fc-day-today .fc-daygrid-day-number {
          align-items: center;
          background-color: #087bc1 !important;
          border-radius: 12px;
          color: #ffffff !important;
          display: inline-flex;
          height: 22px;
          justify-content: center;
          margin: 2px;
          min-width: 22px;
          padding: 0;
        }

        .fc-h-event .fc-event-main {
          font-size: 12px !important;
          line-height: 18px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .fc-daygrid-day-number,
        .fc-daygrid-more-link {
          font-size: 12px;
          line-height: 18px;
        }

        .holiday-cell .fc-daygrid-day-top {
          position: relative;
          right: auto;
          top: auto;
        }

        .holiday-cell .fc-daygrid-day-number {
          height: 22px;
          line-height: 22px;
          margin: 2px;
          width: 22px;
        }

        .holiday-cell .fc-daygrid-day-events {
          padding-top: 0;
        }

        .holiday-event .fc-event-main {
          white-space: nowrap;
        }

        .fc-daygrid-body tr:last-child .holiday-cell .fc-daygrid-day-number[data-holiday-title]:hover::after {
          top: auto;
          bottom: 26px;
        }
      }
    `}
`
